import angular from 'angular';
import tableGridComponent from './tableGrid.component';

let tableGridModule = angular.module('tableGrid', []).component('tableGrid', tableGridComponent);

export default tableGridModule;



// WEBPACK FOOTER //
// ./app/components/tableGrid/tableGrid.js